interface GetTimesheetHeaderTextParams {
  isTimekeepingIntegrationsEnabled: boolean;
  isTimesheetEditDisabled: boolean;
}

export function getTimesheetHeaderText(params: GetTimesheetHeaderTextParams): string {
  const { isTimekeepingIntegrationsEnabled, isTimesheetEditDisabled } = params;

  if (isTimekeepingIntegrationsEnabled) {
    return "The following times have been provided by the facility's internal time clock and cannot be changed here.";
  }

  if (isTimesheetEditDisabled) {
    return "Submit your timesheet now to get paid instantly.";
  }

  return "Make sure the times are correct and make any edits before getting it signed.";
}
